import React from 'react';
import { Input, Label, Select_simple } from "./ui";

const TabIII_Predio = ({ data, onChange }) => {

    const handleChange = (e) => {
        const { name, value } = e.target;
        onChange({ ...data, [name]: value });
    };

    return (
        <div className="space-y-8 p-4 bg-white rounded-lg border border-slate-100">
            
            {/* --- PREGUNTA DISPARADORA --- */}
            <section className="bg-slate-50 p-6 rounded-xl border-2 border-slate-200">
                <h3 className="text-lg font-bold text-slate-800 mb-4">Situación dominial del predio</h3>
                <Label className="text-base mb-3 block">¿La entidad cuenta con predio propio?</Label>
                <div className="flex gap-8">
                    {['Sí', 'No'].map((opcion) => (
                        <label key={opcion} className="flex items-center gap-3 cursor-pointer group">
                            <input 
                                type="radio" 
                                name="cuenta_con_predio" 
                                value={opcion}
                                checked={data.cuenta_con_predio === opcion}
                                onChange={handleChange}
                                className="w-5 h-5 text-blue-600 focus:ring-blue-500"
                            />
                            <span className="text-sm font-bold text-slate-700 group-hover:text-blue-700">{opcion}</span>
                        </label>
                    ))}
                </div>
            </section>

            {/* --- BLOQUE YA NO ES CONDICIONAL --- */}
            
            <div className="space-y-8 animate-in fade-in slide-in-from-top-4 duration-500">

                {/* TIPO DE DOMINIO Y TITULAR */}
                <section className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="space-y-4">
                        <Label>Tipo de dominio</Label>
                        <Select_simple
                            name="tipo_dominio"
                            value={data.tipo_dominio || ''}
                            onChange={handleChange}
                            options={[
                                { value: 'Propiedad', label: 'Propiedad' },
                                { value: 'Cesion', label: 'Cesión municipal' },
                                { value: 'Comodato', label: 'Comodato' },
                                { value: 'Usufructo', label: 'Usufructo' },
                                { value: 'Permiso', label: 'Permiso de uso' },
                                { value: 'Otro', label: 'Otro' }
                            ]}
                            placeholder="Seleccionar..."
                        />
                    </div>
                    <div className="space-y-4">
                        <Label>Titular registral del inmueble</Label>
                        <Input
                            name="titular_registral"
                            placeholder="Nombre del titular o institución"
                            value={data.titular_registral || ''}
                            onChange={handleChange}
                        />
                    </div>
                </section>

                {/* DATOS CATASTRALES */}
                <section className="bg-blue-50/50 p-6 rounded-xl border border-blue-100">
                    <h4 className="text-sm font-bold text-blue-800 uppercase tracking-wider mb-4">Datos Catastrales</h4>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                        <div>
                            <Label className="text-xs">Circunscripción</Label>
                            <Input name="catastro_circ" value={data.catastro_circ || ''} onChange={handleChange} />
                        </div>
                        <div>
                            <Label className="text-xs">Sección</Label>
                            <Input name="catastro_secc" value={data.catastro_secc || ''} onChange={handleChange} />
                        </div>
                        <div>
                            <Label className="text-xs">Manzana</Label>
                            <Input name="catastro_manz" value={data.catastro_manz || ''} onChange={handleChange} />
                        </div>
                        <div>
                            <Label className="text-xs">Parcela</Label>
                            <Input name="catastro_parc" value={data.catastro_parc || ''} onChange={handleChange} />
                        </div>
                    </div>
                    <div className="mt-4">
                        <Label>Superficie aproximada del predio (en m²)</Label>
                        <Input
                            type="number"
                            name="superficie_aprox"
                            className="max-w-xs"
                            value={data.superficie_aprox || ''}
                            onChange={handleChange}
                        />
                    </div>
                </section>

                {/* ESCRITURA E INSCRIPCIÓN */}
                <section className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    <div className="p-4 border rounded-lg">
                        <Label className="mb-3 block">¿Posee escritura traslativa de dominio?</Label>
                        <div className="flex gap-4">
                            {['Sí', 'No'].map(opt => (
                                <label key={opt} className="flex items-center gap-2 cursor-pointer">
                                    <input type="radio" name="posee_escritura" value={opt} checked={data.posee_escritura === opt} onChange={handleChange} className="w-4 h-4 text-blue-600" />
                                    <span className="text-sm">{opt}</span>
                                </label>
                            ))}
                        </div>
                    </div>
                    <div className="p-4 border rounded-lg">
                        <Label className="mb-3 block">¿Inscripto en el Registro de la Propiedad?</Label>
                        <div className="flex gap-4">
                            {['Sí', 'No'].map(opt => (
                                <label key={opt} className="flex items-center gap-2 cursor-pointer">
                                    <input type="radio" name="inscripto_registro" value={opt} checked={data.inscripto_registro === opt} onChange={handleChange} className="w-4 h-4 text-blue-600" />
                                    <span className="text-sm">{opt}</span>
                                </label>
                            ))}
                        </div>
                    </div>
                </section>

                {/* ACTIVIDADES */}
                <section>
                    <Label>Uso del predio</Label>
                    <textarea
                        name="afectacion_actividades"
                        className="w-full mt-2 p-3 border rounded-lg bg-slate-50 focus:ring-2 focus:ring-blue-500 outline-none min-h-[100px] text-sm"
                        placeholder="¿El predio está afectado exclusivamente a actividades deportivas o también a otras actividades comunitarias?"
                        value={data.afectacion_actividades || ''}
                        onChange={handleChange}
                    />
                </section>
            </div>
            
        </div>
    );
};

export default TabIII_Predio;